import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

const ContactSelectOption = ({ data, innerProps, innerRef, label }) => {
  let name = label;
  let extraInfo;
  if (data.name && label.length > data.name.length) {
    name = data.name;
    extraInfo = label.slice(name.length);
  }

  return (
    <div
      aria-label="contact"
      className="d-flex align-items-center gap-3 mx-3 py-2 clickable"
      ref={innerRef}
      {...innerProps}
    >
      <FontAwesomeIcon
        className="text-muted"
        icon={data.isPerson ? faUser : faBriefcase}
      />

      <div className="flex-fill">
        <strong>{name}</strong>{extraInfo}
        <div>{data.business && data.business.name}</div>
      </div>

      <div className="text-muted">{data.source === 'backoffice' ? '' : data.source}</div>
    </div>
  );
};

ContactSelectOption.propTypes = {
  data: PropTypes.shape({
    isPerson: PropTypes.bool,
    source: PropTypes.string.isRequired
  }).isRequired,
  innerProps: PropTypes.object,
  innerRef: PropTypes.object,
  label: PropTypes.string.isRequired
};

export default ContactSelectOption;
